const IMAGE_EXTENSIONS = new Set([
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "svg",
    "avif",
    "bmp",
    "ico",
    "tif",
    "tiff",
]);

const VIDEO_EXTENSIONS = new Set([
    "mp4",
    "webm",
    "mov",
    "avi",
    "mkv",
    "m4v",
    "mpeg",
    "mpg",
    "ogv",
    "3gp",
]);

function getExtension(path) {
    if (typeof path !== "string") return null;

    const cleanPath = path.split("?")[0].split("#")[0];
    const lastDot = cleanPath.lastIndexOf(".");
    if (lastDot === -1 || lastDot === cleanPath.length - 1) return null;

    return cleanPath.slice(lastDot + 1).toLowerCase();
}

export function lookup(path) {
    const ext = getExtension(path);
    if (!ext) return null;

    if (IMAGE_EXTENSIONS.has(ext)) {
        if (ext === "jpg") return "image/jpeg";
        return `image/${ext}`;
    }

    if (VIDEO_EXTENSIONS.has(ext)) {
        if (ext === "ogv") return "video/ogg";
        if (ext === "mpg") return "video/mpeg";
        return `video/${ext}`;
    }

    return null;
}